import { createFileRoute } from '@tanstack/react-router';
import { JourneysGoalHandoff } from '@/pages/workspaces/goals/[goalId]/routing';
import { GoalsRoute, ShowGoalsGate } from './-goals-route';

/** A goal's milestone tab. Forwards to its Hydra page while the rollout flag is on. */
function JourneysGoalMilestonesRoute() {
  const { goalId } = Route.useParams();

  return (
    <ShowGoalsGate>
      <JourneysGoalHandoff goalId={goalId} tab="milestones">
        <GoalsRoute />
      </JourneysGoalHandoff>
    </ShowGoalsGate>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/goals/$goalId_/milestones')({
  component: JourneysGoalMilestonesRoute,
});
